<template>
  <b-col class="mt-0">
  <b-col
      md="12"
      class="mb-2 d-flex align-items-center"
    >
      <b-button
          id="btn-reconciliar"
          class="btn-summary flex-grow-1 d-flex align-items-center justify-content-center mr-2 mb-2"
          @click="refetch"
          :disabled="isRefetching"
        >
        <div v-if="isRefetching" class="dotted-spinner"></div>
        <span v-else>RECONCILIAR VALORES</span>
      </b-button>

        <div id="excel-wrapper" class="mb-2">
          <b-button
            id="btn-excel"
            class="btn-excel"
            @click="$emit('export-excel')"
            :disabled="!hasData || isExporting"
          >
            <div v-if="isExporting" class="dotted-spinner"></div>
            <span v-else>Excel</span>
          </b-button>

        <b-tooltip target="excel-wrapper" triggers="hover" :disabled="hasData">
          Realize uma busca antes de exportar o Excel.
        </b-tooltip>
      </div>
    </b-col>

    <div id="summary">
      <b-col md="12" class="mb-1">
        <b-card class="rent-info-box" @click="$emit('open-table', 'Veripag')">
          <strong>Veripag:</strong>
          <div>{{ formatCurrency(veripag) }}</div>
        </b-card>
      </b-col>

      <b-col md="12" class="mb-1">
        <b-card class="rent-info-box" @click="$emit('open-table', 'PIX')">
          <strong>PIX (Itaú):</strong>
          <div>{{ formatCurrency(pix) }}</div>
        </b-card>
      </b-col>

      <b-col md="12" class="mb-1">
        <b-card class="rent-info-box" @click="$emit('open-table', 'EDI REDE')">
          <strong>EDI REDE:</strong>
          <div>{{ formatCurrency(ediRede) }}</div>
        </b-card>
      </b-col>

      <b-col md="12" class="mb-1">
        <b-card
          class="rent-info-box"
          :class="{ 'highlight-yellow': pending > 0 }"
          @click="$emit('open-table', 'Processando')"
        >
          <strong>Pendentes/Processando:</strong>
          <div>{{ formatCurrency(pending) }}</div>
        </b-card>
      </b-col>

      <b-col md="12" class="mb-1">
        <b-card class="rent-info-box" @click="toggleGatewayDetails">
          <strong>Gateway:</strong>
          <div>{{ formatCurrency(gateway) }}</div>
        </b-card>
      </b-col>
      <b-row v-if="showGatewayDetails" class="mb-2">
        <b-col md="6">
          <b-card
            class="rent-info-box small-card"
            @click="$emit('open-table', 'Gateway - GSurf')"
          >
            <strong>Gsurf:</strong>
            <div>
              {{
                gatewayData.gsurf
                  ? formatCurrency(gatewayData.gsurf.gross_amount)
                  : "R$ 0,00"
              }}
            </div>
          </b-card>
        </b-col>

        <b-col md="6">
          <b-card
            class="rent-info-box small-card"
            @click="$emit('open-table', 'Gateway - PayGo')"
          >
            <strong>Paygo:</strong>
            <div>
              {{
                gatewayData.paygo
                  ? formatCurrency(gatewayData.paygo.gross_amount)
                  : "R$ 0,00"
              }}
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </b-col>
</template>

<script>
import { BCard, BCol, BRow, BButton, BTooltip } from "bootstrap-vue";
import ConciliationEdiRedeService from "@/service/conciliation-edi-rede";

export default {
  components: { BCard, BCol, BRow, BButton, BTooltip },
  props: [
    "pix",
    "veripag",
    "ediRede",
    "pending",
    "gateway",
    "gatewayData",
    "isExporting",
    "initialDate",
    "finalDate",
  ],
  data() {
    return {
      isRefetching: false,
      showGatewayDetails: false,
    };
  },
  computed: {
    hasData() {
      return !! (
        this.pix || 
        this.veripag ||
        this.ediRede ||
        this.pending ||
        this.gateway ||
        (this.gatewayData?.gsurf?.gross_amount ?? 0) > 0 ||
        (this.gatewayData?.paygo?.gross_amount ?? 0) > 0
      );
    },
  },

  methods: {
    formatCurrency(value) {
      if (!value) return "R$ 0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(Number(value));
    },

    async refetch() {
      try {
        this.isRefetching = true;
        await ConciliationEdiRedeService.refetchConciliation({initialDate: this.initialDate,finalDate: this.finalDate,});

        this.$bvToast.toast("Dados conciliados com sucesso!", {
          title: "Sucesso",
          variant: "success",
          solid: true,
          autoHideDelay: 3000,
        });
      } catch (error) {
        console.error("Erro no refetch:", error);

        this.$bvToast.toast("Erro ao reconciliar dados.", {
          title: "Erro",
          variant: "danger",
          solid: true,
          autoHideDelay: 3000,
        });
      } finally {
        this.isRefetching = false;
      }
    },

    toggleGatewayDetails() {
      if (this.gateway) {
        this.showGatewayDetails = !this.showGatewayDetails;
      }
    },
  },
};
</script>

<style scoped>
.rent-info-box {
  text-align: center;
  padding: 1px;
  width: 100%;
  cursor: pointer;
  transition: transform 0.2s ease, background-color 0.3s ease;
}

.small-card {
  font-size: 0.9rem;
  padding: 0.5rem;
}

.highlight-yellow {
  background-color: #fff8dc;
  border: 1px solid #f0e68c;
}

.rent-info-box:hover {
  transform: scale(1.03);
}

.btn-summary {
  background-color: var(--primary) !important;
}

.btn-excel {
  background-color: darkgreen !important;
}

.dotted-spinner {
  width: 22px;
  height: 22px;
  border: 3px dotted #fff;
  border-radius: 50%;
  animation: spin 1.5s linear infinite;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
.btn-summary,
.btn-excel {
  min-height: 45px;  
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap
}

</style>
